var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTimer = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99951 2.83301C11.3086 2.83301 13.9993 5.52392 13.9995 8.83301C13.9995 12.1422 11.3088 14.833 7.99951 14.833C4.69042 14.8328 1.99951 12.1421 1.99951 8.83301C1.99969 5.52403 4.69053 2.83318 7.99951 2.83301ZM7.99951 3.16699C4.87567 3.16717 2.33367 5.70917 2.3335 8.83301C2.3335 11.957 4.87557 14.4998 7.99951 14.5C11.1236 14.5 13.6665 11.9571 13.6665 8.83301C13.6663 5.70906 11.1235 3.16699 7.99951 3.16699Z",
    fill: "#59697D",
    stroke: "#59697D",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.16659C7.72667 9.16659 7.5 8.93992 7.5 8.66659V5.33325C7.5 5.05992 7.72667 4.83325 8 4.83325C8.27333 4.83325 8.5 5.05992 8.5 5.33325V8.66659C8.5 8.93992 8.27333 9.16659 8 9.16659Z",
    fill: "#59697D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.83325H6C5.72667 1.83325 5.5 1.60659 5.5 1.33325C5.5 1.05992 5.72667 0.833252 6 0.833252H10C10.2733 0.833252 10.5 1.05992 10.5 1.33325C10.5 1.60659 10.2733 1.83325 10 1.83325Z",
    fill: "#59697D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timer.d34041dc.svg";
export { ForwardRef as ReactComponent };